/*
 * Easy Fenua — Commande depuis la fiche produit ET depuis le panier, v25 (15/09)
 *
 * DEUX MODES, UN SEUL CODE (data-cod-mode sur la racine) :
 *   'produit' — les articles viennent de la fiche produit (variante, quantité, suggestions cochées)
 *   'panier'  — les articles viennent du panier Shopify (/cart.js), et les +/− y écrivent vraiment
 *
 * - LE DÉFILEMENT VERS LE CHAMP MIS AU POINT EST FAIT PAR LE NAVIGATEUR (v25) — voir « Le clavier
 *   des téléphones » ; il n'y a plus une ligne de JavaScript là-dessus, c'est du CSS
 * - LES NOMS TOUT EN MAJUSCULES SONT ADOUCIS À L'AFFICHAGE (v22) — voir harmoniser()
 * - LA FENÊTRE EST DÉPLACÉE DANS <body> ET LE TIROIR SE REFERME (v20/v21) — voir sortirDuTiroir()
 * - LE BOUTON DISPARAÎT SUR UN PRODUIT ÉPUISÉ (v19) ; au panier, c'est LE THÈME qui le cache quand
 *   le panier est vide (v23) — voir majDisponibilite()
 * - IL A LA MÊME TYPOGRAPHIE PARTOUT, celle de « Ajouter au panier » — voir alignerSurLeTheme()
 * - Charge les ZONES depuis Sona IA (GET {api}/api/cod/zones) ; la liste se replie sur la zone
 *   retenue une fois le choix fait (collapseZones)
 * - LES CHAMPS D'ADRESSE SONT GÉNÉRÉS d'après la zone (zone.form) — voir renderLieu()
 * - CODE PROMO et NOTE : deux champs repliés derrière un lien, même geste (etatPromo / etatNote)
 * - E-MAIL FACULTATIF : transmis à la commande Shopify pour la confirmation et la facture
 * - CGV : case obligatoire, elle barre LES DEUX boutons, et le serveur la revérifie
 * - L'ÉCRAN DE CONFIRMATION mène à la page de suivi Shopify (v18) — voir onSuccess
 *
 * ⚠️ LA FENÊTRE N'EST PLUS DANS `this.root` APRÈS L'INITIALISATION. Tout ce qui la vise passe par
 * `this.overlay`, jamais par `this.root` — voir sortirDuTiroir().
 *
 * ⚠️ CE N'EST PLUS UN <form> (v19) : dans le panier, notre bouton vit à l'intérieur du formulaire
 * du thème, et un <form> imbriqué est supprimé par l'analyseur HTML sans rien dire. Les champs
 * portent donc `data-cod-champ` — voir champ() et l'en-tête de snippets/cod-modal.liquid.
 *
 * ⚠️ LES DEUX BOUTONS DE PAIEMENT PASSENT PAR SONA IA :
 *   « Payer à la livraison »  → POST {api}/api/cod/orders   → commande Shopify, à régler au coursier
 *   « Payer par carte »      → POST {api}/api/cod/checkout → lien de paiement Shopify
 *
 * ⚠️ LES MONTANTS AFFICHÉS ICI SONT EN CENTIMES (Liquid et /cart.js donnent des centimes), et ceux
 * qui viennent de Sona IA sont en XPF entiers. D'où les « * 100 » sur la livraison et la remise.
 * Se tromper là-dessus fait un facteur cent sur le total.
 */
(function () {
  'use strict';

  var FORM_DEFAUT = { placeLabel: 'Commune', placeOptions: [], landmark: true, landmarkLabel: 'Adresse ou point de repère (PK, quartier, maison…)' };

  // La même forme que celle du serveur (voir valider() dans services/cod.js). Volontairement
  // permissive : ce n'est pas au formulaire de décider qu'une adresse existe, seulement d'attraper
  // la faute de frappe évidente avant d'envoyer une facture dans le vide.
  var RE_EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  var QUANTITE_MAX = 20;

  // La racine des routes de la boutique. Sur une boutique multilingue, /cart.js devient /fr/cart.js :
  // Shopify pose la bonne valeur dans Shopify.routes.root, on ne la devine pas.
  var RACINE = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  /* ⚠️ AU-DESSUS DU TIROIR PANIER, ET C'EST MESURÉ, PAS DEVINÉ : le `.drawer__content` du thème Story
     est à 20 050 (relevé le 15/09). Notre feuille de style monte à 10 000, ce qui suffit partout
     ailleurs ; ici, la fenêtre serait passée DERRIÈRE le tiroir. On ne touche pas au z-index du
     thème — c'est le sien —, on passe au-dessus. Le tiroir se referme de toute façon (voir
     fermerLeTiroir) : cette valeur est la ceinture, pas les bretelles. */
  var Z_AU_DESSUS_DU_TIROIR = 999999;

  /* Ce qu'on recopie du bouton du thème : la typographie, rien d'autre.
     🗣️ Nathan, 15/09 : « le bouton du panier est trop gros, je veux quelque chose comme le bouton de
     la page produit, même la police ». D'où DEUX LISTES : sur la fiche produit on recopie tout de
     « Ajouter au panier » ; dans le panier, le seul bouton à imiter serait « Procéder au paiement »,
     qui est plus gros (17 px / 500 contre 16 px / 600, mesuré le 15/09) — on ne lui prend donc que
     la POLICE, et la taille reste la nôtre. Résultat : le même bouton sur tout le site. */
  var TYPO_COMPLETE = ['fontFamily', 'fontSize', 'fontWeight', 'letterSpacing', 'textTransform'];
  var TYPO_POLICE = ['fontFamily', 'letterSpacing', 'textTransform'];
  var SELECTEUR_AJOUT = '.product__submit__add, form[action*="/cart/add"] [name="add"], form[action*="/cart/add"] button[type="submit"]';
  var SELECTEUR_CHECKOUT = '.checkout__button, [name="checkout"]';

  var FALLBACK_ZONES = [
    { code: 'TAHITI_URBAIN', label: 'Tahiti, Arue à Punaauia', price: 0, delay: 'Sous 24 h, hors week-end et jours fériés', cod: true, form: FORM_DEFAUT },
    { code: 'TAHITI_AUTRES', label: 'Tahiti, autres communes', price: 0, delay: 'Tournée une fois par semaine', cod: true, form: FORM_DEFAUT },
    { code: 'MOOREA', label: 'Moorea', price: 1500, delay: '', cod: true, form: FORM_DEFAUT },
    { code: 'ILES', label: 'Autres îles', price: 2500, delay: 'Fret aérien', cod: true, form: FORM_DEFAUT }
  ];

  function fmt(cents) {
    var n = Math.round(cents / 100);
    return n.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ' XPF';
  }

  function uid() {
    if (window.crypto && crypto.randomUUID) return crypto.randomUUID().replace(/-/g, '');
    var s = '';
    for (var i = 0; i < 32; i++) s += Math.floor(Math.random() * 16).toString(16);
    return s;
  }

  function escapeHtml(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* ─── Les noms tout en majuscules, adoucis à l'affichage (v22, 15/09) ────────────── */
  /* 🗣️ Nathan, 15/09 : « si tout le nom est en majuscules, reformate ça : première lettre majuscule
     puis minuscules, pour un visuel harmonieux. »

     ⚠️ ON NE TOUCHE QU'AUX NOMS ENTIÈREMENT EN MAJUSCULES. « SHILAJIT (En goutte) - NUTRITION PRO »
     contient des minuscules : le commerçant a choisi cette casse, on la respecte.

     ⚠️ ET C'EST UNIQUEMENT DE L'AFFICHAGE : la commande envoyée à Shopify ne porte que des
     identifiants de variante, jamais ces libellés.

     Le détour par une boucle plutôt qu'un `/\p{L}/u` : la première LETTRE n'est pas toujours le
     premier caractère (« (RÉSINE PURE) » commence par une parenthèse), et une lettre se reconnaît
     ici à ce qu'elle change en passant en capitale — vrai pour é, à, ô comme pour a. */
  function harmoniser(nom) {
    var s = String(nom == null ? '' : nom).trim();
    if (!s) return s;
    if (s.toLowerCase() === s || s.toUpperCase() !== s) return s;
    var bas = s.toLowerCase();
    for (var i = 0; i < bas.length; i++) {
      var c = bas.charAt(i);
      if (c.toUpperCase() !== c) return bas.slice(0, i) + c.toUpperCase() + bas.slice(i + 1);
    }
    return bas;
  }

  /* ⚠️ LES IMAGES DE /cart.js ARRIVENT EN PLEINE RÉSOLUTION. Mesuré le 15/09 : 3 375 × 4 219 px
     téléchargés pour une vignette de 40 px de côté. Le CDN de Shopify redimensionne à la volée :
     il suffit de le lui demander. Liquid le fait déjà pour la fiche produit (img_url: '160x160').
     Toute URL qui n'est pas servie par ce CDN est rendue telle quelle. */
  function vignette(url, taille) {
    var u = String(url || '');
    if (!u || u.indexOf('cdn.shopify.com') === -1) return u;
    if (/[?&]width=/.test(u)) return u;
    return u + (u.indexOf('?') === -1 ? '?' : '&') + 'width=' + (taille || 160);
  }

  function CodForm(root) {
    this.root = root;
    this.mode = root.getAttribute('data-cod-mode') === 'panier' ? 'panier' : 'produit';
    this.api = root.getAttribute('data-api');
    this.key = root.getAttribute('data-key');
    this.section = this.mode === 'produit' ? (root.closest('[data-section-type="product"]') || document) : document;
    this.tiroir = root.closest('[data-drawer]');
    this.openBtn = root.querySelector('[data-cod-open]');
    this.openLabel = this.openBtn ? (this.openBtn.querySelector('span') || this.openBtn) : null;
    this.noteBouton = root.querySelector('[data-cod-note-bouton]');
    this.overlay = root.querySelector('[data-cod-overlay]');
    this.modal = root.querySelector('.product-cod__modal');
    this.form = root.querySelector('[data-cod-form]');
    this.summary = root.querySelector('[data-cod-summary]');
    this.zoneBox = root.querySelector('[data-cod-zonebox]');
    this.zonesEl = root.querySelector('[data-cod-zones]');
    this.pickedEl = root.querySelector('[data-cod-zone-picked]');
    this.lieuEl = root.querySelector('[data-cod-lieu]');
    this.errorEl = root.querySelector('[data-cod-error]');
    this.errorText = root.querySelector('[data-cod-error-text]');
    this.submitBtn = root.querySelector('[data-cod-submit]');
    this.submitAmount = root.querySelector('[data-cod-submit-amount]');
    this.submitLabel = root.querySelector('[data-cod-submit-label]');
    this.submitLabelText = (this.submitLabel.textContent || '').trim() || 'Payer à la livraison';
    this.payBtn = root.querySelector('[data-cod-pay]');
    this.payLabel = root.querySelector('[data-cod-pay-label]');
    this.payLabelText = this.payLabel ? ((this.payLabel.textContent || '').trim() || 'Payer par carte ou virement') : '';
    this.orEl = root.querySelector('[data-cod-or]');
    this.noCodEl = root.querySelector('[data-cod-nocod]');
    this.promoBox = root.querySelector('[data-cod-promo]');
    this.promoOpen = root.querySelector('[data-cod-promo-open]');
    this.promoSaisie = root.querySelector('[data-cod-promo-saisie]');
    this.promoInput = root.querySelector('[data-cod-promo-input]');
    this.promoApply = root.querySelector('[data-cod-promo-apply]');
    this.promoClose = root.querySelector('[data-cod-promo-close]');
    this.promoOk = root.querySelector('[data-cod-promo-ok]');
    this.promoMsg = root.querySelector('[data-cod-promo-msg]');
    this.noteOpen = root.querySelector('[data-cod-note-open]');
    this.noteSaisie = root.querySelector('[data-cod-note-saisie]');
    this.noteInput = root.querySelector('[data-cod-note-input]');
    this.noteClose = root.querySelector('[data-cod-note-close]');
    this.lienCommande = root.querySelector('[data-cod-order-url]');
    this.cgv = root.querySelector('[data-cod-cgv]');
    this.cgvWrap = root.querySelector('[data-cod-cgv-wrap]');
    this.zones = FALLBACK_ZONES;
    this.zoneCode = null;
    this.promo = null;
    this.codeEnAttente = null;
    this.repere = '';
    this.depart = null;
    this.retires = {};
    this.quantites = {};
    this.panier = null;
    this.panierModifie = false;
    this.idempotencyKey = uid();

    /* Les variantes (mode produit) : { "id": { p: prix en centimes, t: "Rouge / L", d: disponible } }.
       `d` vient de `variant.available` côté Liquid : c'est le verdict de Shopify, pas un calcul de
       stock de notre cru. Le format à plat de la v12 ({ "id": prix }) est encore accepté. */
    this.variants = {};
    var balise = root.querySelector('[data-cod-variants]');
    if (balise) {
      try {
        var brut = JSON.parse(balise.textContent);
        for (var id in brut) {
          if (!Object.prototype.hasOwnProperty.call(brut, id)) continue;
          var v = brut[id];
          this.variants[id] = (v && typeof v === 'object')
            ? { p: Number(v.p) || 0, t: String(v.t || ''), d: v.d === 0 ? 0 : 1 }
            : { p: Number(v) || 0, t: '', d: 1 };
        }
      } catch (e) {
        this.variants = {};
      }
    }

    this.sortirDuTiroir();
    this.bind();
    this.alignerSurLeTheme();
    if (this.mode === 'panier') this.chargerPanier();
    this.majDisponibilite();
    this.loadZones();
  }

  /* ─── La fenêtre sort du tiroir (v20/v21, 15/09) ──────────────────────────── */
  /* 🗣️ Nathan, 15/09 : « pour le panier slide, je ne veux pas le modal dans le sidebar mais au milieu
     de la page entière, comme EasySell le fait avec son bouton du sidebar cart. »

     ⚠️ `position: fixed` NE SE CALE PAS TOUJOURS SUR LA FENÊTRE DU NAVIGATEUR. Dès qu'un ancêtre
     porte un `transform`, un `filter`, un `backdrop-filter`, un `perspective` ou un `contain`, il
     devient le bloc conteneur : notre calque, pourtant en `inset: 0`, se retrouvait enfermé dans la
     largeur du tiroir (`.drawer__content` est en `position: fixed` AVEC un `transform`). Aucune
     valeur de `z-index` ou de `position` n'en sort : la seule façon d'en sortir, c'est d'en sortir.

     ⚠️ CONSÉQUENCE À RETENIR : après cet appel, la fenêtre N'EST PLUS dans `this.root`. Tout ce qui
     la vise doit passer par `this.overlay` — un `this.root.querySelector()` sur un élément de la
     fenêtre rendrait `null` sans rien dire.

     Le ménage d'abord : dans l'éditeur de thème, une section rechargée reconstruit sa racine et on
     rappelle init(). Sans ce retrait, chaque rechargement laisserait un calque orphelin. */
  CodForm.prototype.sortirDuTiroir = function () {
    if (!this.overlay) return;
    var titre = this.modal ? this.modal.getAttribute('aria-labelledby') : '';
    if (titre) {
      document.querySelectorAll('body > [data-cod-overlay][data-cod-titre="' + titre + '"]').forEach(function (vieux) {
        if (vieux.parentNode) vieux.parentNode.removeChild(vieux);
      });
      this.overlay.setAttribute('data-cod-titre', titre);
    }
    // La classe `product-cod` porte les variables de couleur et la police : elle voyage avec le
    // calque, sinon il perdrait tout son style en changeant de parent.
    this.overlay.classList.add('product-cod');
    if (this.tiroir) this.overlay.style.zIndex = String(Z_AU_DESSUS_DU_TIROIR);
    document.body.appendChild(this.overlay);
  };

  /* 🗣️ « … comme EasySell le fait avec son bouton du sidebar cart » : chez eux, le tiroir se referme
     et la fenêtre prend toute la page. On fait pareil, et on le fait AVEC LE BOUTON DU THÈME plutôt
     qu'en retirant sa classe à la main : le thème tient d'autres choses à jour en fermant (blocage
     du défilement, focus, calque du tiroir). */
  CodForm.prototype.fermerLeTiroir = function () {
    if (!this.tiroir) return;
    if (this.tiroir.className.indexOf('drawer--visible') === -1) return;
    var nom = this.tiroir.getAttribute('data-drawer');
    var fermer = this.tiroir.querySelector('.drawer__close, [data-drawer-toggle="' + nom + '"]');
    if (fermer) { try { fermer.click(); } catch (e) {} }
  };

  /* ─── Les champs, sans <form> (v19) ───────────────────────────────────── */
  /* ⚠️ `form.elements.machin` N'EXISTE PLUS : notre conteneur est un <div>. La raison est dans
     l'en-tête de snippets/cod-modal.liquid — un <form> dans le <form> du panier est purement et
     simplement supprimé par l'analyseur HTML, sans erreur, sans trace. */
  CodForm.prototype.champ = function (nom) {
    return this.form.querySelector('[data-cod-champ="' + nom + '"]');
  };

  CodForm.prototype.valeur = function (nom) {
    var el = this.champ(nom);
    return el ? String(el.value || '').trim() : '';
  };

  CodForm.prototype.viderFormulaire = function () {
    this.form.querySelectorAll('[data-cod-champ]').forEach(function (el) {
      if (el.type === 'checkbox' || el.type === 'radio') el.checked = false;
      else el.value = '';
      el.classList.remove('is-invalid');
    });
    if (this.cgv) this.cgv.checked = false;
  };

  /* ─── Le bouton d'ouverture épouse la typographie du thème ─────────────────────── */
  /* ⚠️ ON LIT LE BOUTON DU THÈME, ON NE RECOPIE PAS SES VALEURS. La police de « Ajouter au panier »
     n'est PAS celle du corps de page : sur Easy Fenua, ce bouton est en Figtree alors que tout le
     reste est en Poppins, et AUCUNE variable de thème ne porte cette valeur (vérifié le 15/09).
     Écrire « Figtree » en dur ici, ce serait mentir le jour où Nathan change la police de sa
     boutique. La seule source fiable est le bouton lui-même. */
  CodForm.prototype.boutonTheme = function () {
    if (this.mode === 'panier') {
      var proche = this.root.parentElement ? this.root.parentElement.querySelector(SELECTEUR_CHECKOUT) : null;
      return proche || document.querySelector(SELECTEUR_CHECKOUT);
    }
    var portee = this.section === document ? document : this.section;
    return portee.querySelector(SELECTEUR_AJOUT);
  };

  CodForm.prototype.alignerSurLeTheme = function () {
    var ref = this.boutonTheme();
    if (!ref || !this.openBtn) return;
    var c = window.getComputedStyle(ref);
    var liste = this.mode === 'panier' ? TYPO_POLICE : TYPO_COMPLETE;
    for (var i = 0; i < liste.length; i++) {
      var p = liste[i];
      if (c[p]) this.openBtn.style[p] = c[p];
    }
  };

  /* ─── Y a-t-il quelque chose à commander ? ───────────────────────────────── */
  /* 🗣️ Nathan, 15/09 : « pour les produits ou variantes épuisés, le bouton Shopify affiche déjà
     Épuisé, donc inutile d'un deuxième bouton : il faudrait CACHER notre bouton. »

     DEUX SOURCES EN MODE PRODUIT, ET C'EST VOULU : `variant.available` (le verdict de Shopify, passé
     par Liquid) ET l'état du bouton du thème. Si l'un des deux dit non, c'est non.

     ⚠️ EN MODE PANIER, ON NE CACHE RIEN NOUS-MÊMES (v23, bug trouvé en recette le 15/09).
     On l'avait fait — bouton masqué quand /cart.js répondait « panier vide » — et ça cassait le
     parcours le plus courant : page produit, panier vide, notre bouton se cache ; le client clique
     « Ajouter au panier », le thème remplit le panier en AJAX SANS recharger la page… et notre
     bouton restait caché, parce que notre photo du panier datait du chargement. LE THÈME SAIT : il
     pose `cart--hidden` sur le bloc qui contient notre bouton tant que le panier est vide, et la
     retire dès qu'il y a un article. On le laisse faire. */
  CodForm.prototype.majDisponibilite = function () {
    if (!this.openBtn || this.mode === 'panier') return;

    var ref = this.boutonTheme();
    var v = this.variants[this.variantePrincipale()];
    var epuise = (v && v.d === 0) || !!(ref && ref.disabled);

    this.openBtn.hidden = epuise;
    this.openBtn.disabled = epuise;
    if (this.noteBouton) this.noteBouton.hidden = epuise;

    if (epuise && this.overlay && !this.overlay.hidden && !this.etapeReussite()) this.close();
  };

  CodForm.prototype.etapeReussite = function () {
    var e = this.overlay.querySelector('[data-cod-step="success"]');
    return !!e && !e.hidden;
  };

  CodForm.prototype.bind = function () {
    var self = this;
    if (this.openBtn) this.openBtn.addEventListener('click', function () { self.open(); });
    this.overlay.querySelectorAll('[data-cod-close]').forEach(function (b) {
      b.addEventListener('click', function () { self.close(); });
    });

    /* FERMETURE AU CLIC EXTÉRIEUR — pourquoi ce n'est pas un simple 'click' sur le calque.
       Un `click` est émis sur l'ancêtre COMMUN à l'appui et au relâchement. Appuyer DANS la
       fenêtre — pour sélectionner du texte — et relâcher quelques pixels à côté donnait un click
       sur le calque : la fenêtre se fermait toute seule, la saisie perdue. On exige les deux. */
    var evBas = window.PointerEvent ? 'pointerdown' : 'mousedown';
    var evHaut = window.PointerEvent ? 'pointerup' : 'mouseup';
    this.overlay.addEventListener(evBas, function (e) { self.depart = e.target; });
    this.overlay.addEventListener(evHaut, function (e) {
      var dehors = self.depart === self.overlay && e.target === self.overlay;
      self.depart = null;
      if (dehors) self.close();
    });
    this.overlay.addEventListener('pointercancel', function () { self.depart = null; });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !self.overlay.hidden) self.close();
    });
    this.zonesEl.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-cod-zone]');
      if (!btn) return;
      self.selectZone(btn.getAttribute('data-cod-zone'));
    });
    if (this.pickedEl) {
      this.pickedEl.addEventListener('click', function () { self.expandZones(); });
    }

    /* Les boutons de quantité. Délégués sur le récapitulatif : son contenu est réécrit à chaque
       changement, un écouteur posé sur chaque bouton disparaîtrait avec lui. */
    if (this.summary) {
      this.summary.addEventListener('click', function (e) {
        var b = e.target.closest('[data-cod-qty]');
        if (b) self.changerQuantite(b.getAttribute('data-cod-qty-id'), parseInt(b.getAttribute('data-cod-qty'), 10));
      });
    }

    /* ── Code promo ── */
    if (this.promoOpen) {
      this.promoOpen.addEventListener('click', function () {
        self.etatPromo('saisie');
        if (self.promoInput) self.promoInput.focus();
      });
    }
    if (this.promoApply) this.promoApply.addEventListener('click', function () { self.appliquerPromo(); });
    if (this.promoClose) this.promoClose.addEventListener('click', function () { self.fermerPromo(); });
    if (this.promoInput) {
      /* Entrée dans le champ promo doit APPLIQUER LE CODE, pas envoyer la commande : sans ce garde,
         le réflexe le plus naturel du monde déclenchait le paiement avec un formulaire à moitié
         vide. Échap referme le champ — même sortie de secours que la croix, au clavier. */
      this.promoInput.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') { e.preventDefault(); e.stopPropagation(); self.appliquerPromo(); }
        else if (e.key === 'Escape') { e.preventDefault(); e.stopPropagation(); self.fermerPromo(); }
      });
    }
    if (this.promoOk) {
      this.promoOk.addEventListener('click', function (e) {
        if (e.target.closest('[data-cod-promo-remove]')) self.retirerPromo();
      });
    }

    /* ── Note pour le livreur : même geste que le code promo ── */
    if (this.noteOpen) {
      this.noteOpen.addEventListener('click', function () {
        self.etatNote('saisie');
        if (self.noteInput) self.noteInput.focus();
      });
    }
    if (this.noteClose) this.noteClose.addEventListener('click', function () { self.fermerNote(); });
    if (this.noteInput) {
      this.noteInput.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') { e.preventDefault(); e.stopPropagation(); if (self.noteInput.blur) self.noteInput.blur(); }
        else if (e.key === 'Escape') { e.preventDefault(); e.stopPropagation(); self.fermerNote(); }
      });
    }

    if (this.cgv) {
      this.cgv.addEventListener('change', function () {
        if (self.cgv.checked && self.cgvWrap) self.cgvWrap.classList.remove('is-invalid');
      });
    }

    /* ── Les champs d'adresse, écrits par renderLieu ── */
    if (this.lieuEl) {
      this.lieuEl.addEventListener('change', function (e) {
        var sel = e.target.closest('[data-cod-place]');
        if (sel && sel.tagName === 'SELECT') sel.classList.toggle('est-vide', !sel.value);
      });
      // Le point de repère déjà tapé est mémorisé : changer de zone ne doit pas le faire retaper.
      this.lieuEl.addEventListener('input', function (e) {
        var rep = e.target.closest('[data-cod-landmark]');
        if (rep) self.repere = rep.value;
      });
    }

    if (this.submitBtn) this.submitBtn.addEventListener('click', function () { self.submit(); });
    if (this.payBtn) this.payBtn.addEventListener('click', function () { self.payNow(); });

    /* ⚠️ ENTRÉE DOIT CONTINUER D'ENVOYER LA COMMANDE (v19). Ce réflexe venait du <form> : en le
       retirant, on l'aurait perdu sans que personne ne le dise — le client aurait tapé son numéro,
       appuyé sur Entrée, et rien. Les champs promo et note l'interceptent avant (stopPropagation). */
    this.form.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter') return;
      var el = e.target;
      if (!el || el.tagName !== 'INPUT') return;
      if (el.type === 'checkbox' || el.type === 'radio') return;
      e.preventDefault();
      self.submit();
    });

    this.form.addEventListener('input', function (e) {
      var el = e.target;
      if (el && el.classList) el.classList.remove('is-invalid');
      var tel = el && el.closest && el.closest('.product-cod__field--tel');
      if (tel) tel.classList.remove('is-invalid');
      if (el && el.getAttribute && el.getAttribute('data-cod-champ') === 'phone') self.formaterTelephone(el);
    });

    if (this.mode === 'produit') this.suivreLaFicheProduit();
  };

  /* ─── Le clavier des téléphones, et le défilement vers le champ ─────────────── */
  /* 🗣️ Nathan, 15/09 : « pourquoi le scroll quand je change d'input a l'air de se faire en plusieurs
     petits à-coups ? »

     ⚠️ IL N'Y A PLUS UNE SEULE LIGNE DE JAVASCRIPT ICI, ET C'EST LA CORRECTION (v25). Il y avait
     TROIS défilements pour un seul changement de champ :
       1. celui du navigateur, instantané, quand le champ prend le focus ;
       2. le nôtre, 300 ms plus tard, en `smooth` et centré (amenerAuClavier, v24) ;
       3. sur iPhone, le clavier qui monte et redécoupe la zone visible.
     Trois gestes en une demi-seconde : l'œil lit des à-coups.

     Notre défilement ne servait qu'à UNE chose : éviter que le champ n'atterrisse SOUS le bandeau
     collant. Or le navigateur sait le faire tout seul dès qu'on lui dit combien de place réserver —
     c'est `scroll-padding`, posé sur les deux conteneurs qui défilent (voir « La place du bandeau
     collant » dans cod-form.css). Une propriété CSS à la place d'une minuterie : un seul mouvement,
     au bon endroit, au rythme du système plutôt qu'au nôtre.

     ⚠️ ET ON NE REMET NI MINUTERIE NI visualViewport. C'était l'erreur d'avant la v24 : le
     navigateur connaît la hauteur du clavier, nous non, et aucune API ne la donne de façon fiable
     sur iOS. Relevé chez EasySell le 15/09 : zéro occurrence de `visualViewport` dans leur
     JavaScript. Les deux `scrollIntoView` qui restent dans ce fichier (cgvOk, showError) sont d'une
     autre nature : ils répondent à un clic sur « Payer », pas à une mise au point de champ. */

  /* ─── Suivre le formulaire produit du thème (mode produit) ─────────────────────── */
  /* ⚠️ ON N'OBSERVE QUE LE FORMULAIRE DU THÈME, PAS TOUTE LA SECTION. Notre propre fenêtre vit dans
     cette section et se réécrit sans arrêt (renderSummary) : l'observer en entier nous ferait
     réagir à nos propres écritures, en boucle. */
  CodForm.prototype.suivreLaFicheProduit = function () {
    var self = this;
    var portee = this.section === document ? document : this.section;
    var formTheme = portee.querySelector('form[action*="/cart/add"]');
    if (formTheme && window.MutationObserver) {
      var minuteur = null;
      var obs = new MutationObserver(function () {
        clearTimeout(minuteur);
        minuteur = setTimeout(function () {
          self.alignerSurLeTheme();
          self.majDisponibilite();
          if (!self.overlay.hidden && !self.etapeReussite()) self.renderSummary();
        }, 80);
      });
      obs.observe(formTheme, { subtree: true, childList: true, attributes: true, attributeFilter: ['disabled', 'value', 'class', 'aria-disabled'] });
    }
    // Les thèmes qui changent de variante sans toucher au DOM émettent au moins un `change`.
    portee.addEventListener('change', function () {
      setTimeout(function () {
        self.majDisponibilite();
        if (!self.overlay.hidden && !self.etapeReussite()) self.renderSummary();
      }, 60);
    });
  };

  /* ─── Le panier Shopify (mode panier) ──────────────────────────────────── */
  /* ⚠️ LE PANIER EST LU À CHAQUE OUVERTURE, JAMAIS FIGÉ AU CHARGEMENT. Le tiroir, les +/− du thème
     et un autre onglet modifient le panier sans recharger la page.
     ⚠️ ET LES +/− DE LA FENÊTRE ÉCRIVENT DANS LE VRAI PANIER (/cart/change.js) : deux compteurs
     pour une même chose finissent toujours par se contredire. */
  CodForm.prototype.chargerPanier = function () {
    var self = this;
    return fetch(RACINE + 'cart.js', { headers: { 'Accept': 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (c) {
        if (!c) return null;
        self.panier = c;
        if (!self.overlay.hidden && !self.etapeReussite()) self.renderSummary();
        return c;
      })
      .catch(function () { return null; });
  };

  // `cle` est la clé de LIGNE du panier, pas l'identifiant de variante : un même produit peut
  // occuper deux lignes (propriétés différentes), et changer « la variante » toucherait la mauvaise.
  CodForm.prototype.ecrireAuPanier = function (cle, quantite) {
    var self = this;
    return fetch(RACINE + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ id: cle, quantity: quantite })
    })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (c) {
        if (!c) { self.showError('Le panier n’a pas pu être mis à jour. Recharge la page et réessaie.'); return null; }
        self.panier = c;
        self.panierModifie = true;
        self.renderSummary();
        // Le panier a changé : la remise que Shopify avait calculée dessus ne vaut plus.
        if (self.promo) self.appliquerPromo(self.promo.code, true);
        return c;
      })
      .catch(function () {
        self.showError('Connexion impossible. Vérifie ton réseau et réessaie.');
        return null;
      });
  };

  CodForm.prototype.viderLePanier = function () {
    var self = this;
    return fetch(RACINE + 'cart/clear.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      credentials: 'same-origin'
    })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (c) { if (c) { self.panier = c; self.panierModifie = true; } return c; })
      .catch(function () { return null; });
  };

  /* ─── Zones ──────────────────────────────────────────────────────── */
  CodForm.prototype.loadZones = function () {
    var self = this;
    fetch(this.api + '/api/cod/zones')
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) {
        if (data && Array.isArray(data.zones) && data.zones.length) self.zones = data.zones;
        self.renderZones();
      })
      .catch(function () { self.renderZones(); });
  };

  CodForm.prototype.renderZones = function () {
    var self = this;
    var html = '';
    this.zones.forEach(function (z) {
      var free = !z.price;
      html +=
        '<button type="button" class="product-cod__zone' + (z.code === self.zoneCode ? ' is-on' : '') + '" role="radio" aria-checked="' + (z.code === self.zoneCode ? 'true' : 'false') + '" data-cod-zone="' + escapeHtml(z.code) + '">' +
        '<span class="product-cod__radio" aria-hidden="true"></span>' +
        '<span class="product-cod__zone-name">' + escapeHtml(z.label) + (z.delay ? '<small>' + escapeHtml(z.delay) + '</small>' : '') + '</span>' +
        '<span class="product-cod__zone-price' + (free ? ' is-free' : '') + '">' + (free ? 'Offerte' : fmt(z.price * 100)) + '</span>' +
        '</button>';
    });
    this.zonesEl.innerHTML = html || '<p class="product-cod__zones-wait">Aucune zone de livraison disponible pour le moment.</p>';
    if (this.currentZone()) this.collapseZones();
    else this.expandZones();
    this.majPaiement();
    this.renderLieu();
  };

  CodForm.prototype.selectZone = function (code) {
    var avant = this.zoneCode;
    this.zoneCode = code;
    this.zonesEl.classList.remove('is-invalid');
    this.zonesEl.querySelectorAll('[data-cod-zone]').forEach(function (b) {
      var on = b.getAttribute('data-cod-zone') === code;
      b.classList.toggle('is-on', on);
      b.setAttribute('aria-checked', on ? 'true' : 'false');
    });
    this.collapseZones();
    this.majPaiement();
    this.renderLieu();
    this.renderSummary();

    /* LE CODE MIS EN ATTENTE S'APPLIQUE ICI : un code « livraison offerte » n'a rien à réduire tant
       qu'aucune livraison n'est au panier. Les autres codes se sont appliqués sans attendre. */
    if (this.codeEnAttente) {
      var attendu = this.codeEnAttente;
      this.codeEnAttente = null;
      this.appliquerPromo(attendu);
      return;
    }
    // Changer de zone peut changer la remise — y compris à la PREMIÈRE zone cochée (avant === null).
    if (avant !== code && this.promo) this.appliquerPromo(this.promo.code, true);
  };

  /* ─── Les champs d'adresse de la zone ─────────────────────────────────── */
  /* ⚠️ LE THÈME NE DÉCIDE RIEN ICI. Chaque zone arrive avec ses questions (zone.form), réglées dans
     Sona IA → Paramètres → Zones de livraison.
     ⚠️ L'ÉTIQUETTE SUIT LE CHAMP, JAMAIS L'INVERSE : la feuille de style lit l'état du champ pour
     déplacer ce qui le SUIT (voir « Champs à étiquette flottante » dans cod-form.css).
     ⚠️ LE LIEU PRÉCIS EST VIDÉ À CHAQUE CHANGEMENT DE ZONE : une commune de Tahiti n'a aucun sens
     sur une île. Le point de repère, lui, est REMIS : il ne dépend pas de la zone. */
  CodForm.prototype.renderLieu = function () {
    if (!this.lieuEl) return;
    var dejaTape = this.lieuEl.querySelector('[data-cod-landmark]');
    if (dejaTape) this.repere = dejaTape.value;

    var z = this.currentZone();
    if (!z) { this.lieuEl.innerHTML = ''; return; }
    var f = z.form || FORM_DEFAUT;
    var options = Array.isArray(f.placeOptions) ? f.placeOptions : [];
    var label = f.placeLabel || FORM_DEFAUT.placeLabel;

    var html = '<label class="product-cod__field">';
    if (options.length) {
      html += '<select data-cod-champ="place" data-cod-place class="est-vide" autocomplete="address-level2">' +
        '<option value=""></option>' +
        options.map(function (o) { return '<option value="' + escapeHtml(o) + '">' + escapeHtml(o) + '</option>'; }).join('') +
        '</select>';
    } else {
      html += '<input type="text" data-cod-champ="place" data-cod-place maxlength="60" autocomplete="address-level2" placeholder=" ">';
    }
    html += '<span class="product-cod__etiquette">' + escapeHtml(label) + '</span></label>';

    if (f.landmark !== false) {
      var ll = f.landmarkLabel || FORM_DEFAUT.landmarkLabel;
      html += '<label class="product-cod__field">' +
        '<input type="text" data-cod-champ="address1" data-cod-landmark maxlength="200" autocomplete="street-address" placeholder=" ">' +
        '<span class="product-cod__etiquette">' + escapeHtml(ll) + '</span></label>';
    }
    this.lieuEl.innerHTML = html;

    var rep = this.lieuEl.querySelector('[data-cod-landmark]');
    if (rep && this.repere) rep.value = this.repere;
  };

  /* Une zone en `cod: false` (fret) perd le bouton « Payer à la livraison » et son séparateur ;
     une note prend leur place. On écrit `style.display` plutôt que l'attribut `hidden` : ces deux
     éléments sont en `display: flex` dans la feuille de style, qui l'emporterait sur `hidden`. */
  CodForm.prototype.majPaiement = function () {
    var z = this.currentZone();
    var interdit = !!z && z.cod === false;
    if (this.submitBtn) this.submitBtn.style.display = interdit ? 'none' : '';
    if (this.orEl) this.orEl.style.display = interdit ? 'none' : '';
    if (this.noCodEl) this.noCodEl.hidden = !interdit;
  };

  CodForm.prototype.collapseZones = function () {
    var z = this.currentZone();
    if (!this.pickedEl || !this.zoneBox || !z) return;
    var prix = z.price ? 'Livraison ' + fmt(z.price * 100) : '<span class="is-free">Livraison offerte</span>';
    this.pickedEl.innerHTML =
      '<span class="product-cod__picked-mark" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg></span>' +
      '<span class="product-cod__picked-name">' + escapeHtml(z.label) +
      '<small>' + prix + (z.delay ? ' · ' + escapeHtml(z.delay) : '') + '</small></span>' +
      '<span class="product-cod__picked-edit">Modifier</span>';
    this.pickedEl.setAttribute('aria-label', 'Zone de livraison : ' + z.label + '. Modifier');
    this.pickedEl.hidden = false;
    this.zonesEl.hidden = true;
    this.zoneBox.classList.add('is-collapsed');
  };

  CodForm.prototype.expandZones = function () {
    if (!this.pickedEl || !this.zoneBox) return;
    var etaitReplie = !this.pickedEl.hidden;
    this.pickedEl.hidden = true;
    this.zonesEl.hidden = false;
    this.zoneBox.classList.remove('is-collapsed');
    if (!etaitReplie) return;
    var on = this.zonesEl.querySelector('.is-on');
    if (on && on.focus) {
      try { on.focus({ preventScroll: true }); } catch (e) { on.focus(); }
    }
  };

  CodForm.prototype.currentZone = function () {
    var code = this.zoneCode;
    if (!code) return null;
    for (var i = 0; i < this.zones.length; i++) if (this.zones[i].code === code) return this.zones[i];
    return null;
  };

  CodForm.prototype.formZone = function () {
    var z = this.currentZone();
    return (z && z.form) || FORM_DEFAUT;
  };

  /* ─── Code promo ─────────────────────────────────────────────────── */
  /* ⚠️ LE NAVIGATEUR NE CALCULE RIEN : il demande à Sona IA, qui demande à Shopify. Ce qui s'affiche
     est un aperçu ; le montant qui compte est recalculé à la commande, côté serveur.
     TROIS ÉTATS, UN SEUL VISIBLE : 'replie' → 'saisie' → 'applique'. */
  CodForm.prototype.etatPromo = function (etat) {
    if (this.promoOpen) this.promoOpen.hidden = etat !== 'replie';
    if (this.promoSaisie) this.promoSaisie.hidden = etat !== 'saisie';
    if (this.promoOk) this.promoOk.hidden = etat !== 'applique';
  };

  CodForm.prototype.etatNote = function (etat) {
    if (this.noteOpen) this.noteOpen.hidden = etat !== 'replie';
    if (this.noteSaisie) this.noteSaisie.hidden = etat !== 'saisie';
  };

  CodForm.prototype.fermerNote = function () {
    // Refermer, c'est dire « je n'ai pas de note » : on vide, sinon une remarque tapée puis cachée
    // partirait quand même sur le bon de livraison.
    if (this.noteInput) this.noteInput.value = '';
    this.etatNote('replie');
  };

  CodForm.prototype.messagePromo = function (texte, info) {
    if (!this.promoMsg) return;
    this.promoMsg.textContent = texte || '';
    this.promoMsg.hidden = !texte;
    this.promoMsg.classList.toggle('is-info', !!info);
    if (this.promoBox) this.promoBox.classList.toggle('is-invalid', !!texte && !info);
  };

  CodForm.prototype.fermerPromo = function () {
    this.codeEnAttente = null;
    if (this.promoInput) this.promoInput.value = '';
    this.messagePromo('');
    this.etatPromo(this.promo ? 'applique' : 'replie');
  };

  CodForm.prototype.appliquerPromo = function (codeForce, silencieux) {
    var self = this;
    var code = String(codeForce || (this.promoInput ? this.promoInput.value : '') || '').trim().toUpperCase();
    if (!code) { this.messagePromo('Saisis ton code promo.'); return; }

    var zone = this.currentZone();
    if (this.promoApply) this.promoApply.disabled = true;
    if (!silencieux) this.messagePromo('');

    var corps = {
      code: code,
      lineItems: this.collectItems().map(function (it) { return { variantId: it.variantId, quantity: it.quantity }; })
    };
    if (zone) corps.zone = zone.code;

    fetch(this.api + '/api/cod/promo', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-COD-Key': this.key },
      body: JSON.stringify(corps)
    })
      .then(function (r) {
        return r.json().catch(function () { return {}; }).then(function (data) {
          return { ok: r.ok, status: r.status, data: data };
        });
      })
      .then(function (res) {
        if (self.promoApply) self.promoApply.disabled = false;
        if (!res.ok) {
          var msg = (res.data && res.data.message) || 'Ce code promo n’a pas pu être vérifié.';
          if (res.status === 429) msg = 'Trop de tentatives, réessaie dans une minute.';
          self.promo = null;
          if (self.promoInput) self.promoInput.value = code;
          self.etatPromo('saisie');
          self.messagePromo(msg);
          self.renderSummary();
          return;
        }
        if (res.data && res.data.needsZone) {
          self.promo = null;
          self.codeEnAttente = code;
          if (self.promoInput) self.promoInput.value = code;
          self.etatPromo('saisie');
          self.messagePromo('Ce code porte sur la livraison : choisis ta zone juste en dessous et il s’appliquera tout seul.', true);
          self.expandZones();
          self.renderSummary();
          return;
        }
        self.promo = { code: res.data.code, label: res.data.label, amount: Math.max(0, Math.round(Number(res.data.amount) || 0)) };
        self.messagePromo('');
        self.rendrePromo();
        self.renderSummary();
      })
      .catch(function () {
        if (self.promoApply) self.promoApply.disabled = false;
        if (!silencieux) self.messagePromo('Connexion impossible. Réessaie dans un instant.');
      });
  };

  CodForm.prototype.retirerPromo = function () {
    this.promo = null;
    this.codeEnAttente = null;
    if (this.promoInput) this.promoInput.value = '';
    this.messagePromo('');
    this.etatPromo('saisie');
    this.renderSummary();
    if (this.promoInput) this.promoInput.focus();
  };

  CodForm.prototype.rendrePromo = function () {
    if (!this.promoOk || !this.promo) return;
    this.promoOk.innerHTML =
      '<span class="product-cod__promo-mark" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg></span>' +
      '<span class="product-cod__promo-nom">' + escapeHtml(this.promo.code) +
      '<small>−' + fmt(this.promo.amount * 100) + (this.promo.label && this.promo.label !== this.promo.code ? ' · ' + escapeHtml(this.promo.label) : '') + '</small></span>' +
      '<button type="button" class="product-cod__promo-retirer" data-cod-promo-remove>Retirer</button>';
    this.etatPromo('applique');
  };

  /* ─── Ce qu'il y a à commander ──────────────────────────────────────── */
  CodForm.prototype.variantePrincipale = function () {
    var idInput = this.section.querySelector('form input[name="id"]');
    return String(idInput ? idInput.value : this.root.getAttribute('data-variant-id'));
  };

  /* Chaque article porte un `id` d'affichage : la CLÉ DE LIGNE au panier, l'identifiant de variante
     sur la fiche produit. C'est lui que portent les boutons +/− (data-cod-qty-id). */
  CodForm.prototype.collectItems = function () {
    if (this.mode === 'panier') return this.articlesDuPanier();

    var self = this;
    var items = [];

    var qtyInput = this.section.querySelector('form input[name="quantity"]');
    var variantId = this.variantePrincipale();
    var qty = qtyInput ? Math.max(1, parseInt(qtyInput.value, 10) || 1) : (this.quantites[variantId] || 1);
    var v = this.variants[variantId];
    var price = v ? v.p : (parseInt(this.root.getAttribute('data-variant-price'), 10) || 0);

    if (!this.retires[variantId]) {
      items.push({
        id: variantId,
        variantId: variantId,
        quantity: qty,
        title: this.root.getAttribute('data-product-title'),
        image: this.root.getAttribute('data-product-image') || '',
        price: price,
        hint: (v && v.t) ? v.t : ''
      });
    }

    this.section.querySelectorAll('[data-cross-sell-item]').forEach(function (el) {
      var t = el.querySelector('[data-cross-sell-toggle]');
      if (!t || t.getAttribute('aria-pressed') !== 'true') return;
      var id = String(el.getAttribute('data-variant-id') || '');
      if (!id || self.retires[id]) return;
      var img = el.querySelector('img');
      items.push({
        id: id,
        variantId: id,
        quantity: self.quantites[id] || 1,
        title: el.getAttribute('data-title') || 'Produit',
        image: img ? (img.currentSrc || img.src || '') : '',
        price: parseInt(el.getAttribute('data-price'), 10) || 0,
        hint: 'Suggestion ajoutée'
      });
    });

    return items;
  };

  CodForm.prototype.articlesDuPanier = function () {
    var lignes = (this.panier && this.panier.items) || [];
    return lignes.map(function (l) {
      // Shopify appelle « Default Title » la variante unique d'un produit sans option : un nom
      // technique que le client n'a pas à lire.
      var decl = l.variant_title && l.variant_title !== 'Default Title' ? l.variant_title : '';
      return {
        id: l.key,
        cle: l.key,
        variantId: String(l.variant_id || l.id),
        quantity: l.quantity,
        title: l.product_title || l.title || 'Produit',
        image: vignette(l.image),
        // `final_price` est le prix UNITAIRE remisé, en centimes. `final_line_price` serait la ligne
        // entière : l'utiliser ferait payer la quantité au carré dans computeTotal.
        price: Number(l.final_price) || 0,
        hint: decl
      };
    });
  };

  /* ─── La quantité, réglable dans la fenêtre ──────────────────────────────── */
  /* ⚠️ PERSONNE NE TIENT UN SECOND COMPTEUR. Au panier, les +/− écrivent dans le panier Shopify ;
     sur la fiche produit, ils écrivent dans le champ quantité de la page. Les suggestions font
     exception : la page n'a pas de champ pour elles. */
  CodForm.prototype.changerQuantite = function (id, delta) {
    id = String(id || '');
    if (!id || !delta) return;
    var items = this.collectItems();
    var courant = null;
    for (var i = 0; i < items.length; i++) if (String(items[i].id) === id) courant = items[i];
    if (!courant) return;

    var voulue = courant.quantity + delta;
    // Descendre sous 1, c'est retirer l'article — et retirerArticle refuse de vider la commande.
    if (voulue < 1) { this.retirerArticle(id); return; }
    if (voulue > QUANTITE_MAX) return;

    if (this.mode === 'panier') { this.ecrireAuPanier(courant.cle, voulue); return; }

    var qtyInput = this.section.querySelector('form input[name="quantity"]');
    if (id === this.variantePrincipale() && qtyInput) {
      var d = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, 'value');
      if (d && d.set) d.set.call(qtyInput, String(voulue)); else qtyInput.value = String(voulue);
      qtyInput.dispatchEvent(new Event('input', { bubbles: true }));
      qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
    } else {
      this.quantites[id] = voulue;
    }

    this.renderSummary();
    if (this.promo) this.appliquerPromo(this.promo.code, true);
  };

  /* Retirer un article. « Quand il n'y a qu'un seul produit, ne pas proposer la croix »
     (🗣️ Nathan, 14/09) : elle n'est pas dessinée dans ce cas, ET la fonction refuse quand même de
     tout vider — une consigne d'affichage ne protège pas d'un double clic. */
  CodForm.prototype.retirerArticle = function (id) {
    id = String(id || '');
    if (!id) return;
    var items = this.collectItems();
    if (items.length <= 1) return;

    if (this.mode === 'panier') {
      var ligne = null;
      for (var i = 0; i < items.length; i++) if (String(items[i].id) === id) ligne = items[i];
      if (ligne) this.ecrireAuPanier(ligne.cle, 0);
      return;
    }

    var cible = null;
    this.section.querySelectorAll('[data-cross-sell-item]').forEach(function (el) {
      if (String(el.getAttribute('data-variant-id') || '') === id) cible = el;
    });
    var bouton = cible ? cible.querySelector('[data-cross-sell-toggle]') : null;
    if (bouton) {
      try { bouton.click(); } catch (e) {}
      if (bouton.getAttribute('aria-pressed') === 'true') this.retires[id] = true;
    } else {
      this.retires[id] = true;
    }
    delete this.quantites[id];

    this.renderSummary();
    if (this.promo) this.appliquerPromo(this.promo.code, true);
  };

  CodForm.prototype.computeTotal = function (items, zone) {
    var total = 0;
    items.forEach(function (it) { total += it.price * it.quantity; });
    if (zone) total += zone.price * 100;
    if (this.promo) total -= this.promo.amount * 100;
    return Math.max(0, total);
  };

  CodForm.prototype.renderSummary = function () {
    var items = this.collectItems();
    var z = this.currentZone();
    var retirable = items.length > 1;
    var html = '';

    items.forEach(function (it) {
      // Le nom TEL QU'IL S'AFFICHE (voir harmoniser). `it.title` reste brut pour le reste du code.
      var nom = harmoniser(it.title);
      function bouton(delta, libelle, extra, chemin, inactif) {
        return '<button type="button" class="product-cod__qty-btn' + extra + '"' + (inactif ? ' disabled' : '') +
          ' data-cod-qty="' + delta + '" data-cod-qty-id="' + escapeHtml(it.id) + '"' +
          ' aria-label="' + escapeHtml(libelle) + '">' +
          '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round">' + chemin + '</svg></button>';
      }
      var moins = '';
      if (it.quantity > 1) moins = bouton('-1', 'Enlever un ' + nom, '', '<path d="M5 12h14"/>', false);
      else if (retirable) moins = bouton('-1', 'Retirer ' + nom + ' de ma commande', ' product-cod__qty-btn--retrait', '<path d="M6 6l12 12M18 6L6 18"/>', false);

      html +=
        '<div class="product-cod__line">' +
        '<span class="product-cod__media">' +
        (it.image
          ? '<span class="product-cod__thumb"><img src="' + escapeHtml(it.image) + '" alt="" loading="lazy"></span>'
          : '<span class="product-cod__thumb product-cod__thumb--empty"></span>') +
        '<span class="product-cod__qty" aria-label="Quantité : ' + it.quantity + '">' + it.quantity + '</span>' +
        '</span>' +
        '<span class="product-cod__name">' + escapeHtml(nom) + (it.hint ? '<small>' + escapeHtml(it.hint) + '</small>' : '') + '</span>' +
        '<span class="product-cod__price">' + fmt(it.price * it.quantity) + '</span>' +
        '<span class="product-cod__qtybox">' + moins +
        bouton('1', 'Ajouter un ' + nom, '', '<path d="M12 5v14M5 12h14"/>', it.quantity >= QUANTITE_MAX) +
        '</span>' +
        '</div>';
    });

    if (!items.length) {
      html += '<p class="product-cod__zones-wait">Ton panier est vide.</p>';
    }

    html +=
      '<div class="product-cod__ship"><span>Livraison' + (z ? ' — ' + escapeHtml(z.label) : '') + '</span>' +
      (z ? '<b class="' + (z.price ? '' : 'is-free') + '">' + (z.price ? fmt(z.price * 100) : 'Offerte') + '</b>' : '<b>Choisir une zone</b>') +
      '</div>';

    if (this.promo) {
      html += '<div class="product-cod__ship product-cod__remise"><span>Remise — ' + escapeHtml(this.promo.code) + '</span>' +
        '<b>−' + fmt(this.promo.amount * 100) + '</b></div>';
    }

    /* « Total » tout court : ce récapitulatif sert les DEUX chemins de paiement, et depuis la v14 il
       les engage tous les deux — le montant affiché ici est celui qui sera prélevé. */
    var total = this.computeTotal(items, z);
    html += '<div class="product-cod__total"><span>Total</span><span class="product-cod__amount">' + fmt(total) + '</span></div>';
    this.summary.innerHTML = html;
    this.submitAmount.textContent = fmt(total);
  };

  /* ─── Ouverture / fermeture ────────────────────────────────────────── */
  CodForm.prototype.open = function () {
    // Le tiroir d'abord : il se referme AVANT qu'on pose notre propre blocage du défilement, sinon
    // le thème retire le sien en partant et emporte le nôtre avec.
    this.fermerLeTiroir();

    this.idempotencyKey = uid();
    this.depart = null;
    this.retires = {};
    this.quantites = {};
    this.showStep('form');
    this.hideError();
    this.majPaiement();
    this.renderLieu();
    this.renderSummary();
    // Au panier, on relit /cart.js à CHAQUE ouverture : le tiroir, les +/− du thème ou un autre
    // onglet ont pu changer le panier depuis le chargement de la page.
    if (this.mode === 'panier') this.chargerPanier();
    if (this.cgvWrap) this.cgvWrap.classList.remove('is-invalid');
    this.etatPromo(this.promo ? 'applique' : 'replie');
    // Une note déjà tapée reste visible : la rabattre donnerait l'impression qu'elle a été perdue.
    this.etatNote(this.valeur('note') ? 'saisie' : 'replie');
    this.overlay.hidden = false;
    document.body.classList.add('product-cod-lock');

    /* 🗣️ Nathan, 14/09 : « quand on ouvre le modal je veux que ça soit tout en haut de la page et
       non en bas directement sur l'input prénom, car l'utilisateur doit voir le récap de sa
       commande en premier. » L'ordre de lecture EST l'ordre de la décision.
       ⚠️ DEUX CONTENEURS À REMETTRE EN HAUT depuis la v24 : la carte sur ordinateur, le calque sur
       téléphone (c'est lui qui défile là-bas). Remettre les deux à zéro coûte deux lignes et évite
       de se demander laquelle est la bonne. */
    if (this.modal) this.modal.scrollTop = 0;
    this.overlay.scrollTop = 0;
  };

  CodForm.prototype.close = function () {
    this.depart = null;
    this.overlay.hidden = true;
    document.body.classList.remove('product-cod-lock');

    /* ⚠️ ON RECHARGE SI ON A TOUCHÉ AU PANIER, ET C'EST ASSUMÉ. Le thème tient son propre affichage
       du panier (tiroir, page, pastille du menu) ; nos +/− et le vidage après commande l'ont rendu
       faux. Lui envoyer des événements demanderait de connaître ses conventions internes, qui
       changent à chaque mise à jour de thème. Un rechargement est brutal, mais il ne ment pas — et
       il n'arrive qu'à la fermeture, jamais pendant la saisie. */
    if (this.panierModifie) {
      this.panierModifie = false;
      window.location.reload();
    }
  };

  CodForm.prototype.showStep = function (name) {
    this.overlay.querySelectorAll('[data-cod-step]').forEach(function (s) {
      s.hidden = s.getAttribute('data-cod-step') !== name;
    });
  };

  /* ─── Le téléphone, mis en forme à la frappe ────────────────────────────────── */
  /* Deux raisons, dont une qui n'est pas esthétique : on relit un numéro groupé par deux sans effort,
     et Shopify REFUSE les numéros mal formés — vu en production le 14/09.
     ⚠️ ON NE REFORMATE QUE SI LE CURSEUR EST AU BOUT : au milieu d'une correction, réécrire le champ
     renverrait le curseur à la fin à chaque caractère. */
  CodForm.prototype.formaterTelephone = function (el) {
    var auBout = el.selectionStart === null || el.selectionStart === undefined || el.selectionStart >= el.value.length;
    if (!auBout) return;
    var chiffres = (el.value || '').replace(/\D/g, '');
    // Un numéro collé depuis un carnet d'adresses arrive souvent avec son indicatif.
    if (chiffres.length > 8 && chiffres.indexOf('689') === 0) chiffres = chiffres.slice(3);
    chiffres = chiffres.slice(0, 8);
    var groupe = chiffres.replace(/(\d{2})(?=\d)/g, '$1 ');
    if (groupe === el.value) return;
    el.value = groupe;
    try { el.setSelectionRange(groupe.length, groupe.length); } catch (e) {}
  };

  /* ─── Validation locale (le serveur revalide tout) ────────────────────────────── */
  // Les CGV barrent LES DEUX chemins de paiement : c'est un engagement sur la commande, pas sur le
  // moyen de la régler.
  CodForm.prototype.cgvOk = function () {
    if (!this.cgv) return true;
    if (this.cgv.checked) return true;
    if (this.cgvWrap) {
      this.cgvWrap.classList.add('is-invalid');
      if (this.cgvWrap.scrollIntoView) this.cgvWrap.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
    }
    this.showError('Coche la case des conditions générales de vente pour continuer.');
    return false;
  };

  CodForm.prototype.validate = function () {
    var self = this;
    var ok = true;

    if (!this.collectItems().length) {
      this.showError('Ton panier est vide.');
      return false;
    }
    if (!this.currentZone()) {
      this.expandZones();
      this.zonesEl.classList.add('is-invalid');
      ok = false;
    }
    ['firstName', 'lastName', 'phone'].forEach(function (nom) {
      var el = self.champ(nom);
      if (!el) return;
      var v = (el.value || '').trim();
      var bad = !v;
      if (nom === 'phone' && v) bad = !/^(\+?689[\s.-]?)?(\d[\s.-]?){8}$/.test(v);
      if ((nom === 'firstName' || nom === 'lastName') && v && v.length < 2) bad = true;
      el.classList.toggle('is-invalid', bad);
      var tel = el.closest('.product-cod__field--tel');
      if (tel) tel.classList.toggle('is-invalid', bad);
      if (bad) ok = false;
    });
    /* L'E-MAIL EST FACULTATIF : vide, il passe. Mais rempli DE TRAVERS, il ne passe pas — une
       facture envoyée à une adresse fautive est perdue sans que personne ne le sache. */
    var mail = this.champ('email');
    if (mail) {
      var vm = (mail.value || '').trim();
      var badM = !!vm && !RE_EMAIL.test(vm);
      mail.classList.toggle('is-invalid', badM);
      if (badM) ok = false;
    }
    // Les deux champs suivants n'existent que si la zone les demande.
    var lieu = this.champ('place');
    if (lieu) {
      var badL = !(lieu.value || '').trim();
      lieu.classList.toggle('is-invalid', badL);
      if (badL) ok = false;
    }
    var adr = this.champ('address1');
    if (adr) {
      var badA = (adr.value || '').trim().length < 5;
      adr.classList.toggle('is-invalid', badA);
      if (badA) ok = false;
    }
    return ok;
  };

  CodForm.prototype.firstProblem = function () {
    if (!this.collectItems().length) return 'Ton panier est vide.';
    if (!this.currentZone()) return 'Choisis ta zone de livraison.';
    var form = this.formZone();
    if (!this.valeur('firstName') || !this.valeur('lastName')) return 'Indique ton prénom et ton nom.';
    if (!/^(\+?689[\s.-]?)?(\d[\s.-]?){8}$/.test(this.valeur('phone'))) return 'Numéro de téléphone invalide : 8 chiffres, par exemple 87 12 34 56.';
    var mail = this.valeur('email');
    if (mail && !RE_EMAIL.test(mail)) return 'Adresse e-mail invalide — corrige-la, ou laisse le champ vide.';
    if (this.champ('place') && !this.valeur('place')) return 'Renseigne « ' + (form.placeLabel || 'Commune') + ' » pour continuer.';
    if (this.champ('address1') && this.valeur('address1').length < 5) return 'Renseigne « ' + (form.landmarkLabel || 'Adresse ou point de repère') + ' » pour le livreur.';
    return 'Vérifie les champs signalés.';
  };

  /* LE MÊME CORPS POUR LES DEUX BOUTONS ET LES DEUX MODES. Ce que Sona IA reçoit ne dit pas d'où la
     commande est partie : une liste d'articles, une zone, un client. */
  CodForm.prototype.corps = function () {
    var zone = this.currentZone();
    return {
      idempotencyKey: this.idempotencyKey,
      lineItems: this.collectItems().map(function (it) {
        return { variantId: it.variantId, quantity: it.quantity };
      }),
      firstName: this.valeur('firstName'),
      lastName: this.valeur('lastName'),
      phone: this.valeur('phone'),
      // Facultatif : absent du corps plutôt que vide, pour que le serveur le traite comme non fourni.
      email: this.valeur('email') || undefined,
      zone: zone ? zone.code : undefined,
      place: this.champ('place') ? this.valeur('place') : undefined,
      address1: this.champ('address1') ? this.valeur('address1') : undefined,
      note: this.valeur('note') || undefined,
      promoCode: this.promo ? this.promo.code : undefined,
      termsAccepted: true,
      website: this.valeur('website') || undefined
    };
  };

  CodForm.prototype.messageErreur = function (res) {
    var msg = (res.data && res.data.message) || 'Impossible d’enregistrer la commande pour le moment.';
    if (Array.isArray(msg)) msg = msg.join(' ');
    if (res.status === 429) msg = 'Trop de tentatives, réessaie dans une minute.';
    if (res.status === 401) msg = 'Le formulaire n’est pas correctement configuré. Écris-nous sur Messenger.';
    if (res.status === 400 && /zone de livraison inconnue/i.test(String(msg))) this.expandZones();
    if (res.status === 400 && /code promo/i.test(String(msg))) {
      this.promo = null;
      this.etatPromo('saisie');
      this.messagePromo(msg);
      this.renderSummary();
    }
    return msg;
  };

  CodForm.prototype.envoyer = function (route, corps) {
    return fetch(this.api + route, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-COD-Key': this.key },
      body: JSON.stringify(corps)
    }).then(function (r) {
      return r.json().catch(function () { return {}; }).then(function (data) {
        return { ok: r.ok, status: r.status, data: data };
      });
    });
  };

  /* ─── Payer à la livraison : la commande passe par Sona IA ───────────────────────── */
  CodForm.prototype.submit = function () {
    var self = this;
    this.hideError();

    var zoneChoisie = this.currentZone();
    if (zoneChoisie && zoneChoisie.cod === false) {
      this.showError('Le paiement à la livraison n’est pas disponible pour cette zone. Règle ta commande en ligne, par carte ou par virement.');
      return;
    }
    if (!this.cgvOk()) return;
    if (!this.validate()) {
      this.showError(this.firstProblem());
      return;
    }

    var corps = this.corps();
    this.setLoading(true);

    this.envoyer('/api/cod/orders', corps)
      .then(function (res) {
        self.setLoading(false);
        if (!res.ok) { self.showError(self.messageErreur(res)); return; }
        self.onSuccess(res.data, corps);
      })
      .catch(function () {
        self.setLoading(false);
        self.showError('Connexion impossible. Vérifie ton réseau et réessaie.');
      });
  };

  /* ─── Payer par carte : Sona IA prépare la commande, Shopify encaisse ───────────────── */
  /* 🗣️ Nathan, 14/09 : « je veux le 1, comme EasySell ».

     AVANT, ce bouton fabriquait ICI MÊME un lien de panier : le checkout Shopify rouvrait tout,
     adresse comprise, et refacturait la livraison à SON tarif — or les tarifs de la boutique sont
     des forfaits valables sur toute la Polynésie française, et un client livré à Moorea pouvait
     cocher « Tahiti — 0 XPF ». Le total affiché dans cette fenêtre n'engageait rien.

     MAINTENANT, le formulaire part au serveur, qui crée une commande provisoire portant l'adresse
     ET la ligne de livraison de la zone, et rend son lien de paiement.

     ⚠️ D'OÙ LA VALIDATION COMPLÈTE AVANT D'ENVOYER : le checkout ne rattrapera plus une adresse
     incomplète, c'est la dernière fenêtre où le client peut se corriger.
     ⚠️ ET AUCUN REPLI VERS L'ANCIEN LIEN DE PANIER : si le serveur ne répond pas, on le dit et on
     s'arrête. Repartir par l'ancien chemin rouvrirait le trou sans que personne le voie. */
  CodForm.prototype.payNow = function () {
    var self = this;
    this.hideError();
    if (!this.cgvOk()) return;
    if (!this.validate()) {
      this.showError(this.firstProblem());
      return;
    }

    this.setPayLoading(true);
    this.envoyer('/api/cod/checkout', this.corps())
      .then(function (res) {
        if (!res.ok || !res.data || !res.data.checkoutUrl) {
          self.setPayLoading(false);
          self.showError(res.ok ? 'Impossible de préparer le paiement pour le moment. Réessaie dans un instant.' : self.messageErreur(res));
          return;
        }
        // On NE relâche PAS le bouton : la page s'en va vers le paiement, et un bouton redevenu
        // cliquable pendant la redirection invite à un second clic donc à un second lien.
        window.location.href = res.data.checkoutUrl;
      })
      .catch(function () {
        self.setPayLoading(false);
        self.showError('Connexion impossible. Vérifie ton réseau et réessaie.');
      });
  };

  CodForm.prototype.setPayLoading = function (on) {
    if (!this.payBtn) return;
    this.payBtn.disabled = on;
    if (this.payLabel) this.payLabel.textContent = on ? 'Préparation du paiement…' : this.payLabelText;
  };

  /* ─── L'écran de confirmation ──────────────────────────────────────────── */
  /* Ce qui s'affiche ici vient du SERVEUR, pas de ce qui était à l'écran : le numéro de commande,
     le total réellement enregistré, la remise réellement retenue. Le seul élément repris du
     formulaire est le prénom.
     🗣️ Nathan, 15/09 : « un bouton Détail de ma commande » — c'est `orderUrl`, la page de suivi.
     Elle porte un jeton : elle n'est pas devinable. */
  CodForm.prototype.onSuccess = function (data, payload) {
    // ⚠️ LA FENÊTRE EST DANS <body>, PAS DANS this.root (voir sortirDuTiroir).
    var vue = this.overlay;
    var shipping = data.shipping || {};
    vue.querySelector('[data-cod-order-name]').textContent = data.orderName || '';
    vue.querySelector('[data-cod-success-zone]').textContent = shipping.label || '';
    var delayRow = vue.querySelector('[data-cod-success-delay-row]');
    var delay = shipping.delay || '';
    delayRow.hidden = !delay;
    vue.querySelector('[data-cod-success-delay]').textContent = delay;
    var promoRow = vue.querySelector('[data-cod-success-promo-row]');
    if (promoRow) {
      var d = data.discount;
      promoRow.hidden = !d;
      if (d) vue.querySelector('[data-cod-success-promo]').textContent = d.code + '  −' + fmt((Number(d.amount) || 0) * 100);
    }
    var total = data.total ? Math.round(parseFloat(data.total)) : Math.round(this.computeTotal(this.collectItems(), this.currentZone()) / 100);
    vue.querySelector('[data-cod-success-total]').textContent = fmt(total * 100);
    vue.querySelector('[data-cod-success-phone]').textContent = payload.phone;
    var prenom = vue.querySelector('[data-cod-success-prenom]');
    if (prenom) prenom.textContent = payload.firstName || '';

    /* Le lien vers la page de suivi Shopify. Absent — vieille version du serveur, ou Shopify qui ne
       l'a pas rendu — le bouton reste caché : un bouton mort est pire qu'un bouton absent. */
    if (this.lienCommande) {
      var url = (data.orderUrl || '').trim();
      if (url) this.lienCommande.setAttribute('href', url);
      else this.lienCommande.removeAttribute('href');
      this.lienCommande.hidden = !url;
    }

    this.showStep('success');
    if (this.modal) this.modal.scrollTop = 0;
    this.overlay.scrollTop = 0;

    /* 🗣️ Nathan, 15/09 : le panier est vidé après une commande partie du panier. La commande existe
       chez Shopify ; laisser les mêmes articles au panier, c'est inviter à la passer deux fois — et
       c'est nous qui livrerions deux fois. */
    if (this.mode === 'panier') this.viderLePanier();

    this.viderFormulaire();
    this.zoneCode = null;
    this.promo = null;
    this.codeEnAttente = null;
    this.repere = '';
    this.retires = {};
    this.quantites = {};
    if (this.promoInput) this.promoInput.value = '';
    this.messagePromo('');
    this.etatPromo('replie');
    this.etatNote('replie');
    this.renderZones();
    this.section.querySelectorAll('[data-cross-sell-toggle]').forEach(function (t) {
      t.setAttribute('aria-pressed', 'false');
    });
  };

  CodForm.prototype.setLoading = function (on) {
    this.submitBtn.disabled = on;
    this.submitBtn.classList.toggle('is-loading', on);
    this.submitLabel.textContent = on ? 'Enregistrement…' : this.submitLabelText;
  };

  CodForm.prototype.showError = function (msg) {
    this.errorText.textContent = msg;
    this.errorEl.hidden = false;
    if (typeof this.errorEl.scrollIntoView === 'function') this.errorEl.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
  };

  CodForm.prototype.hideError = function () {
    this.errorEl.hidden = true;
  };

  function init() {
    document.querySelectorAll('[data-cod-root]').forEach(function (root) {
      if (root.getAttribute('data-cod-ready') === 'true') return;
      root.setAttribute('data-cod-ready', 'true');
      new CodForm(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
